import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';


import { MdMenuBook } from "react-icons/md";
import { FaBook } from "react-icons/fa";
import { GiSpellBook } from "react-icons/gi";
import { GiBookmark, GiNotebook } from "react-icons/gi";

import { VscBook } from "react-icons/vsc";
import { PiBookBookmarkDuotone } from "react-icons/pi";

import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import UserContext from '../../UserContext';
import { WsDialogTestUser } from '../Servicing/Test/DialogTestUser';
import { msalInstance } from '../../authConfig';

import { WsPortalContext } from '../PortalContext';

import './Header.scss';

export class WsHeader extends React.Component<any, any> {

  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  static portalContextType = WsPortalContext;
  portalContext!: React.ContextType<typeof WsPortalContext>;

  testUserRef: React.RefObject<WsDialogTestUser>;

  constructor(props: any) {
    super(props);

    this.state = {
      notifications: undefined,
      pendingTests: [],
      userMenuVisible: false,
      selectedRole: this.props.role,
      children: this.props.children
    };

    this.testUserRef = React.createRef<WsDialogTestUser>();
  }



  handleNotifications = (notifications: any) => {
    this.setState({ notifications });
  }

  componentDidMount = () => {
    // this.portalContext?.socketClient.notificationsOn(this.handleNotifications);
  }

  componentWillUnmount() {
    // this.portalContext?.socketClient.notificationsOff(this.handleNotifications);
  }



  Version: React.FC<any> = (props: any) => {
    // console.log('<Version />', props);

    if (window.location.href.indexOf('/servicing/windows') > -1 && window.location.href.indexOf('/servicing/proplus') < 0) {

      const dropdownStyles: Partial<IDropdownStyles> = {
        dropdown: { width: 90 }
      };

      const options: IDropdownOption[] = props.versions.map((version: any) => {

        return { key: version.id, text: version.name, data: { icon: 'RenewalCurrent' } };
      });


      return (
        <Dropdown
          onChange={(event, option) => this.onVersionChange(option, props)}
          onRenderOption={this.onVersionRenderOption}
          options={options}
          selectedKey={props.servicingVersionNumber}
          styles={dropdownStyles}
        />
      );
    } else {
      return null;
    }
  }

  OfficeVersion: React.FC<any> = (props: any) => {
    if (window.location.href.indexOf('/servicing/proplus') > -1 && window.location.href.indexOf('/servicing/windows') < 0) {
      const dropdownStyles: Partial<IDropdownStyles> = {
        dropdown: { width: 90 }
      };

      const options: IDropdownOption[] = [
        { key: 'all',      text: 'ALL',      data: { icon: 'PublicCalendar' } },
        { key: 'Divider0', text: '-',        itemType: DropdownMenuItemType.Divider },

        { key: 'Future',   text: 'Future',   itemType: DropdownMenuItemType.Header },
        { key: '2002',     text: '2002',     data: { icon: 'RenewalFuture' }, disabled: true },
        { key: 'Divider1', text: '-',        itemType: DropdownMenuItemType.Divider },
        { key: 'Latest',   text: 'Latest',   itemType: DropdownMenuItemType.Header },
        { key: '1910',     text: '1910',     data: { icon: 'RenewalCurrent' } },
        { key: 'Divider2', text: '-',        itemType: DropdownMenuItemType.Divider },
        { key: 'Previous', text: 'Previous', itemType: DropdownMenuItemType.Header },
        { key: '1908',     text: '1908',     data: { icon: 'RenewalCurrent' } },
        { key: '1902',     text: '1902',     data: { icon: 'EventAccepted' } },
        { key: '1808',     text: '1808',     data: { icon: 'EventAccepted' } }
      ];

      return (
        <Dropdown
          onChange={(event, option) => this.onVersionChange(option, props)}
          onRenderOption={this.onVersionRenderOption}
          options={options}
          selectedKey={props.servicingVersionNumber}
          styles={dropdownStyles}
        />
      );
    } else {
      return null;
    }
  }

  private onVersionChange = (option: any, props: any) => {
    props.history.push(props.location.pathname.replace(props.servicingVersionNumber, option.key));
  }

  private onVersionRenderOption = (option: any): JSX.Element => {
    return (
      <div>
        {option.data && option.data.icon && (
          <Icon style={{ marginRight: '8px' }} iconName={option.data.icon} aria-hidden="true" title={option.data.icon} />
        )}
        <span>{option.text}</span>
      </div>
    );
  }




  clickEmail = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
  }

  clickTestUser = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    if (this.testUserRef.current) {
      this.testUserRef.current.show();
    }
  }



  render() {

    // console.log(this.context);



    const tabs: any[] = [];

    this.context.environments.forEach((environment: any) => {

      const availableVersions = environment.versions.filter((version: any) => version.available);

      if (availableVersions.length > 0) {
        const tab = tabs.find((t) => t.name === environment.tab);
        if (tab) {
          tab.environments.push(environment);
        } else {
          tabs.push({ name: environment.tab, environments: [ environment ]});
        }
      }
    });


    // console.log(tabs);



    const hasPermissionForTab = (environments: any[]): boolean => {

      let hasPermission = false;

      environments.forEach((environment: any) => {

        if (this.context.hasPermission(`testing/${environment.id}`, 'read')) {
          hasPermission = true;
        }

      });

      return hasPermission;
    };



    const tabsElement = tabs.map((tab) => {

      if (hasPermissionForTab(tab.environments)) {

        const classList = [ 'wsp-header-tab-group' ];

        const environmentsElement = tab.environments.map((environment: any) => {

          if (environment.id === 'ds10') {
            classList.push('wsp-header-tag-group-legacy');
          }

          const hasPermission = this.context.hasPermission(`testing/${environment.id}`, 'read');

          if (hasPermission) {

            const defaultVersion = environment.versions.find((v: any) => v.default);

            return (
              <Fragment key={environment.id}>
                {
                  window.location.pathname.indexOf(`/servicing/windows/${this.props.servicingVersionNumber}/${environment.id}`) === 0
                  ?
                    <a className="navbar-item eg-managed-application is-active">{environment.name} <this.Version versions={environment.versions} history={this.props.history} location={this.props.location} servicingVersionNumber={this.props.servicingVersionNumber} /></a>
                  :
                    <NavLink className="navbar-item eg-managed-application" to={`/servicing/windows/${defaultVersion.id}/${environment.id}`}>{environment.name}</NavLink>
                }
              </Fragment>
            );

          } else {
            return null;
          }
        });

        return (
          <div key={tab.name} className={classList.join(' ')}>
            <div className="wsp-header-tab-group-brackground"></div>
            <div className="wsp-header-tab-group-footer"></div>
            <div className="wsp-header-tab-group-name">
              {tab.name}
            </div>
            {environmentsElement}
          </div>
        );

      } else {
        return null;
      }
    });



    // if (this.portalContext) {
    //   console.log(`portal context : ${this.portalContext.theme}`);
    // }

    // console.log(`props : ${this.props.theme}`);



    return (
      <nav className="navbar eg-header wsp-header" role="navigation" aria-label="main navigation">

        <div className="navbar-brand">
          <a className="navbar-item" href="/welcome">
          {/* <img className="wsp-hp-avanade" src="/logo-avanade-white.png" alt="Decode" /> */}

            {
              this.props.theme === 'marksandspencer'
              ?
              <>
                <img className="wsp-marksandspencer" src="/logo-marksandspencer.png" alt="Decode" />
              </>
              :
              <>
                {
                  this.props.theme === 'riverty'
                  ?
                  <>
                    <img className="wsp-riverty" src="/logo-riverty.png" alt="Decode" />
                  </>
                  :
                  <>
                    {
                      this.props.theme === 'deutschebank'
                      ?
                      <>
                        <img className="wsp-deutschebank" src="/logo-deutschebank.png" alt="Decode" />
                      </>
                      :
                      <>
                        {
                          this.props.theme === 'amadeus'
                          ?
                          <>
                            <img className="wsp-hp" src="/logo-amadeus.png" alt="Decode" />
                          </>
                          :
                          <>
                            {
                              this.props.theme === 'nestle'
                              ?
                              <>
                                <img className="wsp-nestle" src="/v1/logo-nestle-white.png" alt="Decode" />
                              </>
                              :
                              <>
                                {
                                  this.props.theme === 'essex'
                                  ?
                                  <>
                                    <img className="wsp-essex" src="/v1/logo-essex-white.png" alt="Decode" />
                                  </>
                                  :
                                  <>
                                    {
                                      this.props.theme === 'hwb'
                                      ?
                                      <>
                                        <img className="wsp-hwb" src="/v1/logo-hwb.png" alt="Decode" />
                                      </>
                                      :
                                      <>
                                        {
                                        this.props.theme === 'hp'
                                        ?
                                        <>
                                          <img className="wsp-hp" src="/logo-hp.png" alt="Decode" />
                                        </>
                                        :
                                        <>
                                          {
                                            this.props.theme === 'accenture'
                                            ?
                                              <img className="wsp-accenture" src="/logo-accenture-white.png" alt="Decode" />
                                            :
                                            <>
                                              {
                                                this.props.theme === 'client'
                                                ?
                                                <img className="wsp-client"  src="/logo.png" alt="Decode" />
                                                :
                                                <img className="wsp-avanade" src="/v1/logo-avanade-white.png" alt="Decode" />
                                              }
                                            </>
                                          }
                                        </>
                                        }
                                      </>
                                    }
                                  </>
                                }
                              </>
                            }
                          </>
                        }
                      </>
                    }
                  </>
                }
              </>
            }
          </a>
        </div>

        <div className="navbar-start">
          {this.state.children}
        </div>

        <Dropdown
          style={{ display: 'none' }}
          className="ws-theme-switcher"
          options={[
            { key: 'AMADEUS',       text: 'Amadeus'         },
            { key: 'NHS',           text: 'NHS'             },
            { key: 'NATIONAL_GRID', text: 'National Grid'   },
            { key: 'MARKS_SPENCER', text: 'Marks & Spencer' },
            { key: 'SEFE',          text: 'SEFE'            },
            { key: 'CURRYS',        text: 'Currys'          },
            { key: 'URENCO',        text: 'Urenco'          },
            { key: 'SPORTFIVE',     text: 'Sportfive'       },
            { key: 'CANADA_LIFE',   text: 'Canada Life'     },
            { key: 'IRISH_WATER',   text: 'Irish Water'     },
            // { key: 'PARTNER_SALES_PERSON',         text: 'Partner Sales Person'       },
            // { key: 'PARTNER_SOLUTION_ARCHITECT',   text: 'Partner Solution Architect' },
            // { key: 'divider-1', text: '-', itemType:  DropdownMenuItemType.Divider    },
            // { key: 'ACCENTURE_SALES_PERSON',       text: 'Accenture Sales Person'       },
            // { key: 'ACCENTURE_SOLUTION_ARCHITECT', text: 'Accenture Solution Architect' },
            // { key: 'divider-2', text: '-', itemType:  DropdownMenuItemType.Divider    },
            // { key: 'SALES_PERSON',               text: 'Sales Person'               },
            // { key: 'SOLUTION_ARCHITECT',         text: 'Solution Architect'         },
            // { key: 'SOLUTION_AREA_OWNER',        text: 'Solution Area Owner'        },
            // { key: 'SOLUTION_OFFERING_OWNER',    text: 'Solution Offering Owner'    },
            // { key: 'SOLUTION_REVIEWER',          text: 'Solution Reviewer'          },
            // { key: 'DEAL_TEAM',                  text: 'Deal Team'                  },
            // { key: 'divider-3', text: '-', itemType:  DropdownMenuItemType.Divider    },
            // { key: 'CLIENT',                     text: 'Client'                     }
          ]}
          onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
            // console.log(option);

            if (option) {
              if (`${option.key}`.startsWith('PARTNER_')) {
                // this.props.setTheme('hp');
              } else if (`${option.key}`.startsWith('ACCENTURE_')) {
                // this.props.setTheme('accenture');
              } else if (`${option.key}`.startsWith('CLIENT')) {
                // this.props.setTheme('client');
              } else {
                // this.props.setTheme('avanade');
              }

              this.props.setRole(option.key);

              this.setState({ selectedRole: option.key });
            }

          }}
          placeholder="Select Role"
          selectedKey={ this.state.selectedRole }
        />






        {/* {
          window.location.href.indexOf('/servicing/proplus') > -1 ?
          <a className="navbar-item eg-managed-application is-active">Microsoft 365 Apps <this.OfficeVersion history={this.props.history} location={this.props.location} servicingVersionNumber={this.props.servicingVersionNumber} /></a> :
          <NavLink className="navbar-item eg-managed-application" to={`/servicing/proplus/${defaultProPlusServicingVersionNumber}`}>Microsoft 365 Apps</NavLink>
        } */}

        {/* <NavLink className="navbar-item" activeClassName="is-active" to="/administration/managed-products/new">+ Add Other</NavLink> */}

        {/* <WsSearch setSearchResults={this.setSearchResults} /> */}

        <div className="navbar-end">

          <NavLink className="navbar-item" to="/deliver/documentation" onClick={(e) => e.currentTarget.blur()}><PiBookBookmarkDuotone
            style={{
              fontSize: 32
            }}
          /></NavLink>

          <div className={ 'navbar-item has-dropdown eg-user-menu' + (this.state.userMenuVisible ? ' is-hoverable' : '') } onClick={this.userMenuShow} onMouseLeave={this.userMenuHide}>
            <a className="navbar-link">
              <span className="eg-user-photo" style={this.getBackgroundImage()}>
                { !this.getBackgroundImage().backgroundImage && <FontAwesomeIcon icon="user-tie" size="lg" className="eg-user-photo" /> }
              </span>
              {/* { this.state.notifications && this.state.notifications.count > 0 && <FontAwesomeIcon icon="exclamation-circle" size="sm" /> } */}
              {/* Hi, {this.props.currentUser.name} */}
            </a>
            <div className="navbar-dropdown dropdown-right">
              { this.state.notifications && this.state.notifications.count > 0 &&
                <Fragment>
                  <div className="eg-notifications">Notifications:</div>
                  { this.state.notifications.testApproval > 0 && <NavLink className="navbar-item eg-notification" to="/workflows/test-approval" isActive={() => false}>Test Approval <span className="button is-danger is-rounded is-small is-outlined">{this.state.notifications.testApproval}</span></NavLink> }
                  { this.state.notifications.applicationUpgrade > 0 && <NavLink className="navbar-item eg-notification" to="/workflows/application-upgrade" isActive={() => false}>Application Upgrade <span className="button is-danger is-rounded is-small is-outlined">{this.state.notifications.applicationUpgrade}</span></NavLink> }
                  { this.state.notifications.applicationReplacement > 0 && <NavLink className="navbar-item eg-notification" to="/workflows/application-replace" isActive={() => false}>Application Replacement <span className="button is-danger is-rounded is-small is-outlined">{this.state.notifications.applicationReplacement}</span></NavLink> }                  
                  { this.state.notifications.applicationRemoval > 0 && <NavLink className="navbar-item eg-notification" to="/workflows/application-remove" isActive={() => false}>Application Removal <span className="button is-danger is-rounded is-small is-outlined">{this.state.notifications.applicationRemoval}</span></NavLink> }
                  <hr className="navbar-divider" />
                </Fragment>
              }
              <a className="navbar-item" href="#profile-1" onClick={this.clickEmail}>E-mail: {this.props.currentUser.email}</a>
              {/* <a className="navbar-item" href="#profile-1" onClick={this.clickEmail}>Role: {this.props.currentUser.role ? this.props.currentUser.role.name : 'None'}</a>
              <hr className="navbar-divider" />
              <a className="navbar-item" href="#profile-1" onClick={this.clickEmail}>VT1 Account: {this.props.currentUser.account}</a>
              <a className="navbar-item" href="#profile-2" onClick={this.clickTestUser}>VT6 Account: {this.props.currentUser.testUser}</a> */}
              {/* <a className="navbar-item" href="#profile-3">My Profile</a>
              <a className="navbar-item" href="#profile-4">My Devices</a>
              <a className="navbar-item" href="#profile-5">My Applications</a> */}

              <hr className="navbar-divider" />
              <a className="navbar-item" onClick={(e) => { e.preventDefault(); msalInstance.logoutRedirect(); }} href="#profile-6">Sign out</a>
            </div>
          </div>
          <WsDialogTestUser ref={this.testUserRef} />
        </div>



        <div className="navbar-border"></div>
      </nav>
    );
  }

  private getBackgroundImage = () => {
    const photos = {
      'm.balodis@avanade.com':     '/v1/photos/m.balodis@avanade.com.jpeg',
      'd.wood@avanade.com':        '/v1/photos/d.wood@avanade.com.jpeg',
      'd.ames@avanade.com':        '/v1/photos/d.ames@avanade.com.jpeg',
      'keith.hudgell@avanade.com': '/v1/photos/keith.hudgell@avanade.com.jpeg',
    };

    if (photos[this.props.currentUser.email]) {
      return { backgroundImage: `url(${photos[this.props.currentUser.email]})` };
    } else {
      return {};
    }
  }

  private userMenuShow = (event: any) => {
    this.setState({
      userMenuVisible: !this.state.userMenuVisible
    });
  }

  private userMenuHide = () => {
    this.setState({
      userMenuVisible: false
    });
  }

  private setSearchResults = (r: any) => {
    this.props.history.push('/search');
    this.props.setSearchResults(r);
  }
}
